// This component is responsible only for layout

import React, { FunctionComponent } from "react";
import { style } from "typestyle";

interface INavItemProps {
  icon: JSX.Element;
  content: JSX.Element;
  onClick?: () => void;
}
const NavItem: FunctionComponent<INavItemProps> = ({
  icon,
  content,
  onClick,
}: INavItemProps) => (
  <div
    onClick={onClick}
    className={style({
      height: "100%",
      display: "flex",
      alignItems: "center",
      cursor: onClick ? "pointer" : "auto",
    })}
  >
    <div
      className={style({
        marginRight: "16px",
        display: "flex",
        alignItems: "center",
      })}
    >
      {icon}
    </div>
    <div
      className={style({
        display: "flex",
        alignItems: "center",
      })}
    >
      {content}
    </div>
  </div>
);

export default NavItem;
